import React, { useEffect, useState } from "react";
import Collapse from "react-bootstrap/Collapse";
import { useDispatch, useSelector } from "react-redux";
import useConfiguration from "../../hooks/useConfiguration";
import useSessionStorage from "../../hooks/useSessionStorage";
import { ChatWindow } from "../common/chatWindow";
import { deleteNotificationData, getPersonalMsg, sendPersonal, updateArchiveStatus, updateMsgFlag, updateNotificationStatus } from "./action";
import "./index.css";
import Pagination from "react-js-pagination";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { getNotificationCounts } from '../NotificationHeader/action';

const Inbox = ({ content, isOpen, toggle, openChantWindow, removeNotification, notificationStatusHandler, navigateToCandidateView, archievedNotificationHandler }) => {
  return (
    <div className="border-bottom">
      <div className="table-responsive">
        <table
          className="table dataTable no-footer girdtable table-borderless"
          role="grid"
          aria-describedby="myTable_info"
        >
          <tbody>
            <tr>
              <td className="col-5">
                <div class="d-flex align-items-center ">
                  <span onClick={toggle} role="button" className="me-2">
                    {isOpen ? (
                      <i
                        class="fa fa-angle-down"
                        style={{ fontSize: "24px" }}
                      ></i>
                    ) : (
                      <i
                        onClick={() => {
                          if (!content?.isMessageRead) {
                            notificationStatusHandler({ status: true, readBy: content?.candidateInfo?.candidateUniqueId, notifyId: content?.messageId })
                          }
                        }
                        }
                        class="fa fa-angle-right"
                        style={{ fontSize: "24px" }}
                      ></i>
                    )}
                  </span>
                  {
                    !content?.isMessageRead &&
                    <span
                      className="text-center bg-danger text-white rounded-2 p-1 me-2 "
                      style={{ fontSize: "10px" }}
                    >
                      New
                    </span>
                  }
                  <span>{content?.messageText}</span>

                </div>
              </td>
              <td className="col-1">
                <span className="">
                  <i style={{ cursor: "pointer", fontSize: "1rem" }}
                    onClick={() => navigateToCandidateView(content?.candidateInfo)} class="text-primary fe fe-file" ></i>
                </span>
              </td>
              <td className="col-2">
                <span>
                  {content?.messageDateTime} --{" "}
                  {content?.candidateInfo?.firstName +
                    " " +
                    content?.candidateInfo?.lastName}
                </span>
              </td>


              <td className="col-2">
                {content?.isMessageRead ? (
                  <span onClick={() => notificationStatusHandler({ status: false, readBy: content?.candidateInfo?.candidateUniqueId, notifyId: content?.messageId })} style={{ cursor: "pointer" }}>
                    <i className="bi bi-envelope-open fa-lg text-primary"></i>{" "}
                    Read
                  </span>
                ) : (
                  <span onClick={() => notificationStatusHandler({ status: true, readBy: content?.candidateInfo?.candidateUniqueId, notifyId: content?.messageId })} style={{ cursor: "pointer" }}>
                    <i class="bi bi-envelope fa-lg text-primary"></i> Mark as
                    Read
                  </span>
                )}
              </td>


              <td className="col-2">
                {content?.isArchived ? (
                  <span onClick={() => archievedNotificationHandler({ status: 0, readBy: content?.candidateInfo?.candidateUniqueId, notifyId: content?.messageId })} style={{ cursor: "pointer" }}>
                    <i className="fa fa-archive fa-lg text-primary"></i>{" "}
                    Unarchive
                  </span>
                ) : (
                  <span onClick={() => archievedNotificationHandler({ status: 1, readBy: content?.candidateInfo?.candidateUniqueId, notifyId: content?.messageId })} style={{ cursor: "pointer" }}>
                    <i class="fa fa-archive fa-lg text-primary"></i> Archive
                  </span>
                )}
              </td>


              <td className="col-1">
                <i style={{ cursor: "pointer", fontSize: "1rem" }}
                  onClick={() => removeNotification(content.messageId, content?.candidateInfo?.candidateUniqueId)} class="text-primary fe fe-trash-2" ></i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      {/* <div className='d-flex justify-content-sm-between'>
                <div>
                    <span onClick={toggle} role="button" className='me-4'>{isOpen ? <i class="fa fa-angle-down" style={{ 'fontSize': '24px' }}></i> : <i class="fa fa-angle-right" style={{ 'fontSize': '24px' }}></i>}</span>
                    <span className="text-center bg-danger text-white rounded-3 p-1 me-2">New</span> {content?.messageText}</div>
                <span>{content?.messageDateTime}</span>
                <span onClick={() => { openChantWindow(content?.jobInfo?.jobUniqueId, content?.candidateInfo?.candidateUniqueId) }}><i className="bi bi-reply fa-lg text-success"></i> Reply</span>
                {content?.isMessageRead ? <span><i className="bi bi-envelope-open fa-lg text-primary"></i> Read</span> : <span><i class="bi bi-envelope fa-lg text-primary"></i> Mark as Read</span>}
            </div> */}
      {/* <Collapse in={isOpen} className="content">
        <div className="row mt-3 ms-4">
          <span className="fw-bolder">
            <h4>Shift Info</h4>
          </span>
          <div className="row">
            <div className="col-md-4">
              <label className="form-label">Shift Code:</label>
              <label>{content?.jobInfo?.jobCode}</label>
            </div>
            <div className="col-md-4">
              <label className="form-label">Shift Date:</label>
              <label>{content?.jobInfo?.jobDateToDisplay}</label>
            </div>
            <div className="col-md-4">
              <label className="form-label">Shift Title:</label>
              <label>{content?.jobInfo?.jobTitle}</label>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <label className="form-label">Shift Description:</label>
              <label
                dangerouslySetInnerHTML={{
                  __html: content?.jobInfo?.jobDescription,
                }}
              ></label>
            </div>
            <div className="col-md-4">
              <label className="form-label">Checked In Date:</label>
              <label>{content?.jobInfo?.checkedInDateToDisplay}</label>
            </div>
            <div className="col-md-4">
              <label className="form-label">Checked Out Date:</label>
              <label>{content?.jobInfo?.checkedOutDateToDisplay}</label>
            </div>
          </div>

          <div className="row">
            <div className="col-md-4">
              <label className="form-label">Shift Start Time:</label>
              <label>{content?.jobInfo?.shiftStartTime}</label>
            </div>
            <div className="col-md-4">
              <label className="form-label">Shift End Time:</label>
              <label>{content?.jobInfo?.shiftEndTime}</label>
            </div>
            <div className="col-md-4">
              <label className="form-label">Shift Hours:</label>
              <label>{content?.jobInfo?.shiftHours}</label>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <label className="form-label">Paid Date:</label>
              <label>{content?.jobInfo?.paidDateToDisplay}</label>
            </div>
          </div>
        </div>
      </Collapse> */}
      {/* <hr style={{
                color: 'black',
                backgroundColor: 'black',
                height: 1
            }} /> */}
    </div>
  );
};

export default (props) => {
  const { chat, msgSendFlag } = useSelector(state => state.notifications);
  const [isOpen, setIsOpen] = useState(null);
  const [openMessaging, setOpenMessaging] = useState(false);
  const [chatData, setChatData] = useState([]);
  const [msgParams, setmsgParams] = useState({
    webPageId: 0,
    shiftUniqueId: "",
    candidateUniqueId: "",
    employerUniqueId: "",
  });

  const {
    handlePageChange,
    currentPage,
    pageSize,
    totalCount,
    handlePageSize,
    onSort,
  } = props;

  const dispatch = useDispatch();
  const config = useConfiguration();
  const storage = useSessionStorage();
  const login = storage.getItem("login");
  const navigate = useNavigate()
  const toggleOpen = (id) => () => {
    setIsOpen((isOpen) => (isOpen === id ? null : id));
  };

  const openChantWindow = (shiftUniqueId, candidateUniqueId) => {
    if (shiftUniqueId && candidateUniqueId) {
      setmsgParams({
        webPageId: 0,
        shiftUniqueId: shiftUniqueId,
        candidateUniqueId: candidateUniqueId,
        employerUniqueId: login.employerUniqueId,
        employerUserId: login.employerUserId,
      });
      const newparams = {
        webPageId: 0,
        shiftUniqueId: shiftUniqueId,
        candidateUniqueId: candidateUniqueId,
        employerUniqueId: login.employerUniqueId,
        employerUserId: login.employerUserId,
      };
      dispatch(
        getPersonalMsg({
          url: `${config.baseUrl}/Messages/GetEmployerMessages`,
          params: newparams,
        })
      );
      setOpenMessaging(!openMessaging);
    }
  };

  const sendMsg = (text) => {
    const newparams = {
      ...msgParams,
      fromCandidate: false,
      messageText: text,
    };
    dispatch(
      sendPersonal({
        url: `${config.baseUrl}/Messages/SendMessageToCandidate`,
        params: newparams,
      })
    );
  };

  useEffect(() => {
    if (msgSendFlag && config.baseUrl) {
      dispatch(
        getPersonalMsg({
          url: `${config.baseUrl}/Messages/GetEmployerMessages`,
          params: msgParams,
        })
      ).then(() => {
        dispatch(updateMsgFlag(false));
      });
    }
  }, [msgSendFlag]);

  useEffect(() => {
    const newData = JSON.parse(JSON.stringify(chat));
    buildGroupMsg(newData);
  }, [chat]);

  const buildGroupMsg = (data) => {
    const groups = data.reduce((groups, messages) => {
      const date = messages.messageDateTime.split("T")[0];
      if (!groups[date]) {
        groups[date] = [];
      }
      groups[date].push(messages);
      return groups;
    }, {});

    const groupMsg = Object.keys(groups).map((date) => {
      return {
        date,
        messages: groups[date],
      };
    });
    setChatData(groupMsg);
  };
  const removeNotification = (notificationId, candidateUniqueId) => {
    dispatch(deleteNotificationData({
      url: config.baseUrl,
      notificationId: notificationId,
      candidateUniqueId
    }))
  }
  const notificationStatusHandler = ({ status, readBy, notifyId }) => {
    const notificationStatusParams = {
      "messageId": notifyId,
      "messageReadBy": readBy,
      "isMessageRead": status,
      "shiftUniqueId": "",
      "readDate": moment(new Date()).utc().format(),
      "appMessageType": 2
    }
    dispatch(updateNotificationStatus({
      url: config.baseUrl,
      notificationStatusParams: notificationStatusParams
    })).then(() => {
      dispatch(getNotificationCounts(config.baseUrl))
    })
  }


  const archievedNotificationHandler = ({ status, readBy, notifyId }) => {
    const notificationStatusParams = {
      "messageId": notifyId,
      "candidateUniqueId": readBy,
      "isArchived": status,
      // "shiftUniqueId": "",
      // "readDate": moment(new Date()).utc().format(),
      // "appMessageType": 2
    }
    dispatch(updateArchiveStatus({
      url: config.baseUrl,
      notificationStatusParams: notificationStatusParams
    })).then(() => {
      dispatch(getNotificationCounts(config.baseUrl))
    })
  }

  const navigateToCandidateView = (candidateInfo) => {
    navigate("/candidatesearchview",
      {
        state: {
          userData: candidateInfo,
          // loctionId: form.locationId,
          backpage: "/notifications",
        },
      })
  }
  return (
    <div className="card">
      <div className="card-header">
        <div className="col-lg-4 col-md-4">
          <h5 className="card-title">Uploads</h5>
        </div>
      </div>
      <div className="card-body">
        <div className="d-inline-flex align-items-center ">
          <label class="mb-0 pe-2">Show</label>
          <select
            name="myTable_length"
            class="form-control form-select"
            value={pageSize}
            aria-controls="myTable"
            onChange={(e) => handlePageSize(Number(e.target.value))}
          >
            {[10, 25, 50, 100].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                {pageSize}
              </option>
            ))}
          </select>
          <span className="Entries"> entries</span>
        </div>
        {props.messageData &&
          props.messageData.length > 0 &&
          props.messageData.map((item, index) => (
            <Inbox
              key={index}
              content={item}
              isOpen={isOpen === index}
              toggle={toggleOpen(index)}
              openChantWindow={openChantWindow}
              removeNotification={removeNotification}
              notificationStatusHandler={notificationStatusHandler}
              navigateToCandidateView={navigateToCandidateView}
              archievedNotificationHandler = {archievedNotificationHandler}
            />
          ))}
        {openMessaging && chatData.length > 0 && (
          <div className="message-position">
            <ChatWindow
              closeChatWindow={() => {
                setOpenMessaging(!openMessaging);
              }}
              chatData={chatData}
              sendMsg={sendMsg}
            />
          </div>
        )}
      </div>
      <div class="d-flex justify-content-between align-items-center mb-4">
        <div
          className="dataTables_info ps-3"
          id="myTable_info"
          role="status"
          aria-live="polite"
        >
          Showing Page{" "}
          <strong>
            {currentPage} of {Math.ceil(totalCount / pageSize)}
          </strong>
        </div>
        <div class="pe-3 mb-4">
          <Pagination
            itemClass="page-item" // add it for bootstrap 4
            linkClass="page-link" // add it for bootstrap 4
            activePage={currentPage}
            itemsCountPerPage={pageSize}
            totalItemsCount={totalCount}
            pageRangeDisplayed={5}
            onChange={handlePageChange}
          />
        </div>
      </div>
    </div>
  );
};
